function isApiResponse(value) {
  return typeof value === 'object' && value !== null && 'code' in value && 'data' in value;
}
export async function unwrapResponse(requestPromise) {
  const response = await requestPromise;
  const payload = response.data;
  return isApiResponse(payload) ? payload.data : payload;
}